import React from 'react';
import { Box } from '@material-ui/core';
import { FileUploadGallery } from '@campfire/file-upload-gallery';
import { ActivityHeader } from './ActivityHeader';
import { ActivityAttachments as ActivityAttachmentType } from './__generated__/ActivityAttachments';

interface ActivityAttachmentsProps {
  activityAttachments: ActivityAttachmentType[];
}

export function ActivityAttachments({ activityAttachments }: ActivityAttachmentsProps) {
  const attachments =
    activityAttachments?.map((attachment) => ({
      name: attachment.name,
      url: attachment.url,
      fileId: attachment.activityAttachmentId,
    })) || [];

  if (!activityAttachments || activityAttachments.length === 0) {
    return null;
  }

  return (
    <Box marginTop='2rem'>
      <ActivityHeader title='Attachments' />
      <Box>
        <FileUploadGallery allowMultiple uploadedFiles={attachments} viewOnly />
      </Box>
    </Box>
  );
}
